module.exports = __webpack_public_path__ + "static/media/feat-underground-img2.8c241f11.jpg";